import fr from './fr.json';
import en from './en.json';
import nl from './nl.json';
import de from './de.json';
import es from './es.json';
import it from './it.json';
import el from './el.json';
import pt from './pt.json';

export const translations = {
  fr,
  en,
  nl,
  de,
  es,
  it,
  el,
  pt
};

export const languages = [
  { code: 'fr', name: 'Francais', flag: 'FR' },
  { code: 'en', name: 'English', flag: 'GB' },
  { code: 'nl', name: 'Nederlands', flag: 'NL' },
  { code: 'de', name: 'Deutsch', flag: 'DE' },
  { code: 'es', name: 'Espanol', flag: 'ES' },
  { code: 'it', name: 'Italiano', flag: 'IT' },
  { code: 'el', name: 'Ellinika', flag: 'GR' },
  { code: 'pt', name: 'Portugues', flag: 'PT' }
];

export const defaultLanguage = 'fr';

// Helper function to get nested translation value
export const getTranslation = (translations, path) => {
  const keys = path.split('.');
  let value = translations;

  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return path; // Return the path if translation not found
    }
  }

  return value;
};

export default translations;
